import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { showToast } from "../../Helpers/showToast";
import { useSelector, useDispatch } from "react-redux";
import { DateToShow } from "../../Helpers/DateToShow";
import { DateToShowSplit } from "../../Helpers/DateToShowSplit";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import html2pdf from 'html2pdf.js';
import { numberToWords } from "amount-to-words";

export const PrintReport = forwardRef(({ TxnName, printRef, Led_Whatsaap, Led_Email, SONO, EmailBSMSDetails, handleModalCloseEmail, Brok_Whatsapp, handleModalCloseBSMS, printRefFN }, ref) => {

  useImperativeHandle(ref, () => ({
    printReport,
    sendEmail,
    sendBSMS,
    sendBSMSToAgent,
    printReportFN,
  }));

  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const [Loader, setLoader] = useState(false);

  const printReport = () => {

    const printContent = printRef.current.innerHTML;
    const WinPrint = window.open("", "_blank");
    WinPrint?.document?.write(`<html>
          <head>
           <meta charset="utf-8" />
    <link rel="icon" href="/EasyTrade2.png" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta
      name="description"
      content="Web site created using create-react-app"
    />
    <link rel="apple-touch-icon" href="/logo192.png" />

    <link rel="manifest" href="/manifest.json" />

    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"
      rel="stylesheet"
      integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65"
      crossorigin="anonymous"
    />
    <link
      rel="stylesheet"
      href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
    />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap"
      rel="stylesheet"
    />

    <link
      href="https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css"
      rel="stylesheet"
    />
    <title>Easy-Trade</title>
            <style>
            body{
            font-family: "poppins";
            }
            .print-box {
  width: 100%;
  height: 100vh;
  // overflow-y: scroll;
  background-color: #f0f2f5;
  padding: 0 20px 0 20px;
}
  
.bill-header-comp {
  /* background-color: #f2f2f2; */
  border-bottom: 3px solid #000;
  display: flex;
  justify-content: space-between;
  /* padding: 1rem; */
}

.bill-header {
  /* background-color: #f2f2f2; */
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

.bill-header-left {
  display: flex;
  align-items: center;
}

.bill-header-left img {
  height: 50px;
  margin-right: 1rem;
}

.bill-header-right {
  display: flex;
  align-items: center;
}

.bill-header-right div {
  margin-left: 1rem;
}

.bill-header-title {
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
}

.bill-header-subtitle {
  font-size: 1.2rem;
  margin: 0;
}

.bill-body-table {
  border-collapse: collapse;
  width: 100%;
}

.bill-body-table_IGST {
  border-collapse: separate;
  width: 100%;
}

.bill-body-table th,
.bill-body-table td {
  border: 1px solid #000;
  padding: 0.5rem;
  text-align: left;
}

.bill-body-table th {
  background-color: #ccc;
  font-weight: bold;
}

.bill-body-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.bill-footer {
  background-color: #f2f2f2;
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

.bill-footer-left {
  display: flex;
  align-items: center;
}

.bill-footer-right {
  display: flex;
  align-items: center;
}

.bill-footer-text {
  font-size: 1.2rem;
  margin: 0;
}

.bill-footer-text-strong {
  font-weight: bold;
}

.bill-footer-text-small {
  font-size: 0.8rem;
  margin-top: 0.5rem;
  display: block;
}

.table-head th {
  height: 20px;
  line-height: 12px;
  max-height: 45px;
  padding: 4px;
}

.table-body td {
  height: 25px;
  line-height: 12px;
  max-height: 50px;
  padding: 4px;
}

.table-body td.receipt {
  height: 25px;
  line-height: 20px;
  max-height: 50px;
}

.table-head-text {
  color: #000;
  font-family: "Poppins";
  font-size: 12px;
  font-weight: 600;
}

.table-body-text {
  color: #000;
  font-family: "Poppins";
  font-size: 14px !important;
  font-weight: 500;
}

td.table-head-text {
  color: #000;
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 600;
}

              @page {
              margin: 0;
                  }
              body {
                margin: 0;
              padding: 0;
                  }
              @media print {
                body * {
                  visibility: hidden!important;
                }   
                  .print-only, .print-only * {
                    visibility: visible!important;
                  }
      
                    .print-only {
                position: absolute !important;
              left: 0;
              top: 0;
        }
      }
            </style>
          </head>
          <body>
            <div class="print-box">${printContent}</div>
            </div>
          </body>
        </html>`);
    WinPrint?.document?.close();
    if (WinPrint) {
      WinPrint.onload = function () {
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
      };
    }
  };

  const generatePDF = async () => {
    return new Promise((resolve, reject) => {
      html2pdf()
        .from(printRef.current)
        .set({
          margin: 10,
          filename: `${TxnName} ("${SONO}").pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { format: "a4", orientation: "portrait" }, // Set A4 size
        })
        .toPdf()
        .get("pdf")
        .then(pdf => {
          const reader = new FileReader();
          reader.readAsDataURL(pdf.output("blob"));
          reader.onloadend = () => {
            const base64String = reader.result.split(",")[1]; // Remove prefix
            resolve(base64String);
          };
          reader.onerror = reject;
        });
    });
  };

  const sendEmail = async () => {
    const pdfBase64 = await generatePDF();
    setLoader(true);

    const emailContent = [
      `From: Your Name <${EmailBSMSDetails?.EMWP_From_Email}>`,
      `To: ${Led_Email}`,
      `Subject: ${EmailBSMSDetails?.EMWP_MailSubject}`,
      `MIME-Version: 1.0`,
      `Content-Type: multipart/mixed; boundary="boundary123"`,
      ``,
      `--boundary123`,
      `Content-Type: text/plain; charset="UTF-8"`,
      `Content-Transfer-Encoding: 7bit`,
      ``,
      ` ${EmailBSMSDetails?.EMWP_MailBody}`,
      ``,
      `--boundary123`,
      `Content-Type: application/pdf; name=${`${TxnName} ("${SONO}").pdf`}`,
      `Content-Disposition: attachment; filename=${`${TxnName} ("${SONO}").pdf`}`,
      `Content-Transfer-Encoding: base64`,
      ``,
      pdfBase64, // Attach the Base64 PDF
      ``,
      `--boundary123--`,
    ].join("\r\n");


    const encodedMessage = btoa(unescape(encodeURIComponent(emailContent)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");

    try {
      const response = await fetch(
        "https://www.googleapis.com/gmail/v1/users/me/messages/send",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${EmailBSMSDetails?.EMWP_Token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ raw: encodedMessage }),
        }
      );
      const result = await response.json();

      setLoader(false);

      if (!response.ok) {
        return showToast(result?.error?.status == "UNAUTHENTICATED" ? "Your Token has Expired" : "Failed to Send Email", "error");
      }

      showToast("Email sent successfully", "success");
      handleModalCloseEmail();
    } catch (error) {
      setLoader(false);
      showToast("Error sending email", "error");
    }
  };


  const generatePDFBlob = async () => {
    return new Promise((resolve, reject) => {
      html2pdf()
        .from(printRef.current)
        .set({
          margin: 10,
          filename: `${TxnName} ("${SONO}").pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { format: "a4", orientation: "portrait" },
        })
        .toPdf()
        .get("pdf")
        .then(pdf => {
          const pdfBlob = pdf.output("blob"); // Get Blob from pdf
          const file = new File([pdfBlob], `${TxnName} ("${SONO}").pdf`, { type: "application/pdf" });
          resolve(file);
        })
        .catch(reject);
    });
  };

  const sendBSMS = async () => {
    const pdfBlob = await generatePDFBlob();

    setLoader(true);

    const formData = new FormData();
    formData.append("file", pdfBlob);

    var requestOptions = {
      method: "POST",
      body: formData,
    };

    const response = EmailBSMSDetails?.EMWP_IsWithOnlyDocument ? await fetch(`https://${EmailBSMSDetails?.WebAddress}/api/sendFiles?token=${EmailBSMSDetails?.InsteanceId}&phone=91${Led_Whatsaap}`, requestOptions) : EmailBSMSDetails?.EMWP_IsWithDoc ? await fetch(`https://${EmailBSMSDetails?.WebAddress}/api/sendFileWithCaption?token=${EmailBSMSDetails?.InsteanceId}&phone=91${Led_Whatsaap}&message=${EmailBSMSDetails?.EMWP_WhatsappText}`, requestOptions) : await fetch(`https://${EmailBSMSDetails?.WebAddress}/api/sendText?token=${EmailBSMSDetails?.InsteanceId}&phone=91${Led_Whatsaap}&message=${EmailBSMSDetails?.EMWP_WhatsappText}`, { method: "POST" })

    const result = await response.json();

    setLoader(false);

    if (!response.ok) {
      return showToast("Failed to Send BSMS", "error")
    }

    showToast("BSMS sent successfully", "success");
    handleModalCloseBSMS();
  };

  const sendBSMSToAgent = async () => {
    const pdfBlob = await generatePDFBlob();

    setLoader(true);

    const formData = new FormData();
    formData.append("file", pdfBlob);

    var requestOptions = {
      method: "POST",
      body: formData,
    };

    const response = EmailBSMSDetails?.EMWP_IsWithOnlyDocument ? await fetch(`https://${EmailBSMSDetails?.WebAddress}/api/sendFiles?token=${EmailBSMSDetails?.InsteanceId}&phone=91${Brok_Whatsapp}`, requestOptions) : EmailBSMSDetails?.EMWP_IsWithDoc ? await fetch(`https://${EmailBSMSDetails?.WebAddress}/api/sendFileWithCaption?token=${EmailBSMSDetails?.InsteanceId}&phone=91${Brok_Whatsapp}&message=${EmailBSMSDetails?.EMWP_WhatsappText}`, requestOptions) : await fetch(`https://${EmailBSMSDetails?.WebAddress}/api/sendText?token=${EmailBSMSDetails?.InsteanceId}&phone=91${Brok_Whatsapp}&message=${EmailBSMSDetails?.EMWP_WhatsappText}`, { method: "POST" })

    const result = await response.json();

    setLoader(false);

    if (!response.ok) {
      // return showToast("Failed to Send BSMS to Agent", "error");
    }

    // showToast("BSMS to Agent sent successfully", "success");
    handleModalCloseBSMS();
  };

  const printReportFN = () => {

    const printContent = printRefFN.current.innerHTML;
    const WinPrint = window.open("", "_blank");
    WinPrint.document.write(`<html>
          <head>
           <meta charset="utf-8" />
    <link rel="icon" href="/EasyTrade2.png" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta
      name="description"
      content="Web site created using create-react-app"
    />
    <link rel="apple-touch-icon" href="/logo192.png" />

    <link rel="manifest" href="/manifest.json" />

    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"
      rel="stylesheet"
      integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65"
      crossorigin="anonymous"
    />
    <link
      rel="stylesheet"
      href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
    />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap"
      rel="stylesheet"
    />

    <link
      href="https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css"
      rel="stylesheet"
    />
    <title>Easy-Trade</title>
            <style>
            body{
            font-family: "poppins";
            }
            .print-box {
  width: 100%;
  height: 100vh;
  // overflow-y: scroll;
  background-color: #f0f2f5;
  padding: 0 20px 0 20px;
}
  
.bill-header-comp {
  /* background-color: #f2f2f2; */
  border-bottom: 3px solid #000;
  display: flex;
  justify-content: space-between;
  /* padding: 1rem; */
}

.bill-header {
  /* background-color: #f2f2f2; */
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

.bill-header-left {
  display: flex;
  align-items: center;
}

.bill-header-left img {
  height: 50px;
  margin-right: 1rem;
}

.bill-header-right {
  display: flex;
  align-items: center;
}

.bill-header-right div {
  margin-left: 1rem;
}

.bill-header-title {
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
}

.bill-header-subtitle {
  font-size: 1.2rem;
  margin: 0;
}

.bill-body-table {
  border-collapse: collapse;
  width: 100%;
}

.bill-body-table_IGST {
  border-collapse: separate;
  width: 100%;
}

.bill-body-table th,
.bill-body-table td {
  border: 1px solid #000;
  padding: 0.5rem;
  text-align: left;
}

.bill-body-table th {
  background-color: #ccc;
  font-weight: bold;
}

.bill-body-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.bill-footer {
  background-color: #f2f2f2;
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

.bill-footer-left {
  display: flex;
  align-items: center;
}

.bill-footer-right {
  display: flex;
  align-items: center;
}

.bill-footer-text {
  font-size: 1.2rem;
  margin: 0;
}

.bill-footer-text-strong {
  font-weight: bold;
}

.bill-footer-text-small {
  font-size: 0.8rem;
  margin-top: 0.5rem;
  display: block;
}

.table-head th {
  height: 20px;
  line-height: 12px;
  max-height: 45px;
  padding: 4px;
}

.table-body td {
  height: 25px;
  line-height: 12px;
  max-height: 50px;
  padding: 4px;
}

.table-body td.receipt {
  height: 25px;
  line-height: 20px;
  max-height: 50px;
}

.table-head-text {
  color: #000;
  font-family: "Poppins";
  font-size: 12px;
  font-weight: 600;
}

.table-body-text {
  color: #000;
  font-family: "Poppins";
  font-size: 14px !important;
  font-weight: 500;
}

td.table-head-text {
  color: #000;
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 600;
}

              @page {
              margin: 0;
                  }
              body {
                margin: 0;
              padding: 0;
                  }
              @media print {
                body * {
                  visibility: hidden!important;
                }   
                  .print-only, .print-only * {
                    visibility: visible!important;
                  }
      
                    .print-only {
                position: absolute !important;
              left: 0;
              top: 0;
        }
      }
            </style>
          </head>
          <body>
            <div class="print-box">${printContent}</div>
            </div>
          </body>
        </html>`);
    WinPrint.document.close();
    WinPrint.onload = function () {
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    };
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: 9999 }}
        open={Loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
});